"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactConfig = require("@okee-uikit/react-config");

var _config = require("./config");

var _excluded = ["className", "style", "onClick", "theme", "size", "fill", "strokeWidth", "strokeLinecap", "strokeLinejoin"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var hyphenateRE = /\B([A-Z])/g;
var defaultConfig = _config.DEFAULT_ICON_CONFIGS;

function withWrapper(type, Component) {
  function Icon(props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick,
        _props$theme = props.theme,
        theme = _props$theme === void 0 ? defaultConfig.theme : _props$theme,
        _props$size = props.size,
        size = _props$size === void 0 ? defaultConfig.size : _props$size,
        _props$fill = props.fill,
        fill = _props$fill === void 0 ? 'currentColor' : _props$fill,
        _props$strokeWidth = props.strokeWidth,
        strokeWidth = _props$strokeWidth === void 0 ? defaultConfig.strokeWidth : _props$strokeWidth,
        _props$strokeLinecap = props.strokeLinecap,
        strokeLinecap = _props$strokeLinecap === void 0 ? defaultConfig.strokeLinecap : _props$strokeLinecap,
        _props$strokeLinejoin = props.strokeLinejoin,
        strokeLinejoin = _props$strokeLinejoin === void 0 ? defaultConfig.strokeLinejoin : _props$strokeLinejoin,
        extra = _objectWithoutPropertiesLoose(props, _excluded);

    var classNameArr = ["" + (0, _reactConfig.usePrefixCls)('icon'), "" + (0, _reactConfig.usePrefixCls)('icon-' + type.replace(hyphenateRE, '-$1').toLowerCase())];

    if (className) {
      classNameArr.push(className);
    }

    var colors = Array.isArray(fill) ? fill : [fill];
    var config = (0, _react.useMemo)(function () {
      var config = {
        outFillColor: colors[1] || defaultConfig.outFillColor,
        innerStrokeColor: colors[2] || defaultConfig.innerStrokeColor,
        innerFillColor: colors[3] || defaultConfig.innerFillColor
      };

      if (theme === 'outline') {
        Object.assign(config, {
          outFillColor: 'transparent',
          innerFillColor: 'transparent',
          innerStrokeColor: colors[0]
        });
      }

      if (theme === 'filled') {
        Object.assign(config, {
          outFillColor: colors[0],
          innerFillColor: '#FFF',
          innerStrokeColor: '#FFF'
        });
      }

      if (theme === 'two-tone') {
        Object.assign(config, {
          outFillColor: colors[1] || defaultConfig.outFillColor,
          innerFillColor: colors[1] || defaultConfig.outFillColor,
          innerStrokeColor: colors[0]
        });
      }

      return config;
    }, [colors, theme]);
    return _react.default.createElement("span", {
      className: classNameArr.join(' '),
      style: style,
      onClick: onClick
    }, _react.default.createElement(Component, _extends({
      size: size,
      strokeWidth: strokeWidth,
      strokeLinecap: strokeLinecap,
      strokeLinejoin: strokeLinejoin,
      outStrokeColor: colors[0]
    }, config, extra)));
  }

  Icon.displayName = type;
  return Icon;
}

var _default = withWrapper;
exports.default = _default;